import React, { useEffect, useState } from 'react';
import { Button, Table } from 'react-bootstrap';
import { JhiItemCount, JhiPagination, TextFormat, getPaginationState } from 'react-jhipster';
import { Link, useLocation, useNavigate } from 'react-router';

import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';

import { getEntities } from './mensaje.reducer';

export const Mensaje = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const mensajeList = useAppSelector(state => state.mensaje.entities);
  const loading = useAppSelector(state => state.mensaje.loading);
  const totalItems = useAppSelector(state => state.mensaje.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const { order } = paginationState;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="mensaje-heading" data-cy="MensajeHeading">
        Mensajes
        <div className="d-flex justify-content-end">
          <Button className="me-2" variant="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} /> Refresh list
          </Button>
          <Link to="/mensaje/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp; Create a new Mensaje
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {mensajeList?.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  ID <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('nombreCliente')}>
                  Nombre Cliente <FontAwesomeIcon icon={getSortIconByFieldName('nombreCliente')} />
                </th>
                <th className="hand" onClick={sort('numeroCelular')}>
                  Numero Celular <FontAwesomeIcon icon={getSortIconByFieldName('numeroCelular')} />
                </th>
                <th className="hand" onClick={sort('referencia')}>
                  Referencia <FontAwesomeIcon icon={getSortIconByFieldName('referencia')} />
                </th>
                <th className="hand" onClick={sort('concepto')}>
                  Concepto <FontAwesomeIcon icon={getSortIconByFieldName('concepto')} />
                </th>
                <th className="hand" onClick={sort('monto')}>
                  Monto <FontAwesomeIcon icon={getSortIconByFieldName('monto')} />
                </th>
                <th className="hand" onClick={sort('timestampLimite')}>
                  Timestamp Limite <FontAwesomeIcon icon={getSortIconByFieldName('timestampLimite')} />
                </th>
                <th className="hand" onClick={sort('timestampSolicitud')}>
                  Timestamp Solicitud <FontAwesomeIcon icon={getSortIconByFieldName('timestampSolicitud')} />
                </th>
                <th className="hand" onClick={sort('idMensajeCobro')}>
                  Id Mensaje Cobro <FontAwesomeIcon icon={getSortIconByFieldName('idMensajeCobro')} />
                </th>
                <th className="hand" onClick={sort('edoPet')}>
                  Edo Pet <FontAwesomeIcon icon={getSortIconByFieldName('edoPet')} />
                </th>
                <th className="hand" onClick={sort('extra1')}>
                  Extra 1 <FontAwesomeIcon icon={getSortIconByFieldName('extra1')} />
                </th>
                <th className="hand" onClick={sort('extra2')}>
                  Extra 2 <FontAwesomeIcon icon={getSortIconByFieldName('extra2')} />
                </th>
                <th className="hand" onClick={sort('extra3')}>
                  Extra 3 <FontAwesomeIcon icon={getSortIconByFieldName('extra3')} />
                </th>
                <th className="hand" onClick={sort('extra4')}>
                  Extra 4 <FontAwesomeIcon icon={getSortIconByFieldName('extra4')} />
                </th>
                <th className="hand" onClick={sort('extra5')}>
                  Extra 5 <FontAwesomeIcon icon={getSortIconByFieldName('extra5')} />
                </th>
                <th className="hand" onClick={sort('extra6')}>
                  Extra 6 <FontAwesomeIcon icon={getSortIconByFieldName('extra6')} />
                </th>
                <th className="hand" onClick={sort('extra7')}>
                  Extra 7 <FontAwesomeIcon icon={getSortIconByFieldName('extra7')} />
                </th>
                <th className="hand" onClick={sort('extra8')}>
                  Extra 8 <FontAwesomeIcon icon={getSortIconByFieldName('extra8')} />
                </th>
                <th className="hand" onClick={sort('extra9')}>
                  Extra 9 <FontAwesomeIcon icon={getSortIconByFieldName('extra9')} />
                </th>
                <th className="hand" onClick={sort('extra10')}>
                  Extra 10 <FontAwesomeIcon icon={getSortIconByFieldName('extra10')} />
                </th>
                <th className="hand" onClick={sort('createdBy')}>
                  Created By <FontAwesomeIcon icon={getSortIconByFieldName('createdBy')} />
                </th>
                <th className="hand" onClick={sort('createdDate')}>
                  Created Date <FontAwesomeIcon icon={getSortIconByFieldName('createdDate')} />
                </th>
                <th className="hand" onClick={sort('lastModifiedBy')}>
                  Last Modified By <FontAwesomeIcon icon={getSortIconByFieldName('lastModifiedBy')} />
                </th>
                <th className="hand" onClick={sort('lastModifiedDate')}>
                  Last Modified Date <FontAwesomeIcon icon={getSortIconByFieldName('lastModifiedDate')} />
                </th>
                <th>
                  Cliente <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {mensajeList.map(mensaje => (
                <tr key={`entity-${mensaje.id}`} data-cy="entityTable">
                  <td>
                    <Button as={Link as any} to={`/mensaje/${mensaje.id}`} variant="link" size="sm">
                      {mensaje.id}
                    </Button>
                  </td>
                  <td>{mensaje.nombreCliente}</td>
                  <td>{mensaje.numeroCelular}</td>
                  <td>{mensaje.referencia}</td>
                  <td>{mensaje.concepto}</td>
                  <td>{mensaje.monto}</td>
                  <td>
                    {mensaje.timestampLimite ? <TextFormat type="date" value={mensaje.timestampLimite} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>
                    {mensaje.timestampSolicitud ? (
                      <TextFormat type="date" value={mensaje.timestampSolicitud} format={APP_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{mensaje.idMensajeCobro}</td>
                  <td>{mensaje.edoPet}</td>
                  <td>{mensaje.extra1}</td>
                  <td>{mensaje.extra2}</td>
                  <td>{mensaje.extra3}</td>
                  <td>{mensaje.extra4}</td>
                  <td>{mensaje.extra5}</td>
                  <td>{mensaje.extra6}</td>
                  <td>{mensaje.extra7}</td>
                  <td>{mensaje.extra8}</td>
                  <td>{mensaje.extra9}</td>
                  <td>{mensaje.extra10}</td>
                  <td>{mensaje.createdBy}</td>
                  <td>{mensaje.createdDate ? <TextFormat type="date" value={mensaje.createdDate} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{mensaje.lastModifiedBy}</td>
                  <td>
                    {mensaje.lastModifiedDate ? <TextFormat type="date" value={mensaje.lastModifiedDate} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>{mensaje.cliente ? <Link to={`/cliente/${mensaje.cliente.id}`}>{mensaje.cliente.nombre}</Link> : ''}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button as={Link as any} to={`/mensaje/${mensaje.id}`} variant="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button
                        as={Link as any}
                        to={`/mensaje/${mensaje.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        variant="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button
                        onClick={() =>
                          (globalThis.location.href = `/mensaje/${mensaje.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        variant="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && <div className="alert alert-warning">No Mensajes found</div>
        )}
      </div>
      {totalItems ? (
        <div className={mensajeList && mensajeList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Mensaje;
